<script module lang="ts">
  import type { AccordionSectionStoryblok } from "~/component-types-sb";
  import type { Snippet } from "svelte";
  export interface AccordionSectionProps {
    blok: AccordionSectionStoryblok;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { storyblokEditable, StoryblokComponent } from "@storyblok/svelte";
  import { Section } from "@agapi/ui/section";
  import { Accordion } from "@agapi/ui/accordion";

  const { blok, ...props }: AccordionSectionProps = $props();
</script>

<Section
  use={[[storyblokEditable, blok]]}
  {...props}
  colorVariant={blok.color_variant}
  containerStyles={{
    flexDir: blok.direction === 'horizontal' ? 'row' : 'column',
    py: blok.vertical_spacing,
  }}
  containerWidth={blok.container_width}
>
  <Accordion>
    {#each blok?.items ?? [] as item}
      <StoryblokComponent blok={item} />
    {/each}
  </Accordion>
</Section>
